
import { mapState, mapGetters } from 'vuex'
import cms from '~/mixins/common/cms'
export default {
    name: 'NavBar',
    mixins: [cms],
    data: () => ({
        drawer: true,
        mini: false,
        hostname: null,
        gameIndex: null,
    }),
    computed: {
        ...mapState({
            isLogin: (state) => state.settings.isLogin,
            player: (state) => state.player.player,
            menubars: (state) => state.cms.menus.menus,
            onHoldWallet: (state) => state.player.onHoldWallet,
            activityWallet: (state) => state.player.activityWallet,
            missionsSettings: (state) =>
                state.activities['mission-reward'].missionsSettings,
            isApp: (state) => state.app.isApp,
        }),
        ...mapGetters({
            headerLogo: 'cms/headerLogo',
            getRegistrationSuspendByCurrency:
                'settings/getRegistrationSuspendByCurrency',
        }),
    },
    watch: {
        '$route.query.idx'(value) {
            this.gameIndex = value
        },
    },
    mounted() {
        this.hostname = window.location.hostname
        if (this.$route?.query?.idx) {
            this.gameIndex = this.$route.query.idx
        }
        if (!this.isMobileOnly())
            this.$store.dispatch('cms/cmsComponentCode', {
                platform: 1,
                component_code: 'HeaderLogo',
            })
        if (this.$cookie.get('token')) {
            if (this.player.player_id) return
            this.$store.dispatch('player/profile')
            this.$store.dispatch('settings/toggleIsLogin', true)
            this.$store.dispatch('player/totalBalance')
        }
    },
    methods: {},
}
